export const flattenReviewGroups = groups =>
  (groups || []).flatMap(group =>
    (group.locations || []).map(loc => ({
      id: loc.id,
      group_id: group.id,
      reviewer: group.reviewer || null,
      location_code: loc.location_code,
      counter: loc.counter || null,
      divergent_products: loc.divergent_products ?? 0,
      status: loc.status,
      review_attempts: loc.review_attempts ?? 0,
      submitted_at: loc.submitted_at || null,
      _location: loc,
    })),
  )

// The server caps `locations` at 100 per group and flags the ones it trimmed;
// `total_locations` still carries the true count so the UI can point at what's hidden.
export const truncatedGroups = groups =>
  (groups || [])
    .filter(group => group.locations_truncated)
    .map(group => ({
      id: group.id,
      reviewer: group.reviewer || null,
      total_locations: group.total_locations,
      shown: (group.locations || []).length,
    }))

export const selectionStatus = rows => {
  if (!rows || rows.length === 0) return null
  const statuses = new Set(rows.map(r => r.status))
  return statuses.size > 1 ? 'mixed' : [...statuses][0]
}

// The reassign dialog reads batches; batches are split by group AND status
// so mixed-state detection keeps working (dialogs reject mixed groups).
export const toBatchesForReassign = rows => {
  const byGroup = {}
  ;(rows || []).forEach(r => {
    const key = `${r.group_id}::${r.status}`
    if (!byGroup[key]) byGroup[key] = { id: key, status: r.status, reviewer: r.reviewer, operator: r.reviewer, locations: [] }
    byGroup[key].locations.push(r._location)
  })
  return Object.values(byGroup)
}
